import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconEmailNewsletter = ({
  classes = '',
  styles,
  width = '30px',
  height = '30px',
  color = 'currentColor',
}) => {
  return (
    <Svg
      viewBox='0 0 72 72'
      className={classes}
      styles={styles}
      width={width}
      height={height}
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
    >
      <title>Email</title>
      <Path
        color={color}
        d='M64.01,62.64H8.86V29.96l27.58-20.59,27.58,20.59v32.68ZM45.27,33.08h-1.91c-2.43,3.08-9.09,3.16-11.93.77-3.33-2.8-2.58-8.79.79-11.24,2.38-1.73,6.86-1.94,9.16.02s2.32,5.68.18,7.8c-.35.35-1.98,1.61-1.99.46l1.55-7.36h-2.49l-.13.94c-.13.03-.13-.05-.19-.11-.5-.55-.88-.91-1.67-1.02-5.17-.77-7.73,8.06-3.35,9.67,1.28.47,2.82.2,3.76-.81.24.59.54.94,1.21,1.01,4.53.46,7.32-4.35,6.33-8.41-1.59-6.47-11.21-6.73-14.89-2.1-3.99,5.01-2.34,12.71,4.36,14.17,3.93.86,9.28.22,11.22-3.8ZM10.81,59.89l20.36-15.69-20.36-13.6v29.29ZM62.07,30.59l-20.29,13.67,20.29,15.62v-29.29ZM60.45,60.96l-24.02-18.59-24.02,18.59h48.04Z'
      />
      <Path
        color={color}
        d='M35.98,24.97c.85-.1,1.59.41,1.83,1.23.42,1.47-.46,4.88-2.16,5.29-3.51.84-2.48-6.18.33-6.52Z'
      />
    </Svg>
  )
}

const Svg = styled(SvgAttr)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.styles};
`

const Path = styled.path`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`
